<template>
  <transition name="fade">
    <div class="modal" v-show="show">
      <div class="modal-back" @click="show=false"></div>
      <div class="modal-ctx">
        <div class="modal-ti">{{title}}</div>
        <div class="img-ctx">
          <img :src="img" class="modal-img" v-if="img">
          <div class="img-place" v-else-if="placeholder" v-html="placeholder"></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: "Modal",
    data () {
      return {
        title: '',
        img: 'https://zk-static-1301841918.cos.ap-nanjing.myqcloud.com/qr.jpg',
        fn: null,
        placeholder: "",
        show: true
      }
    },
    watch: {
      show() {
        if(!this.show && typeof this.fn === "function") {
          this.fn();
        }
      }
    }
  };
</script>

<style lang="less">
  .modal {
    z-index: 101;
  }
  .modal-back {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,.75);
  }
  .modal-ctx {
    position: fixed;
    top: 25vh;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 48px 0;
    width: 600px;
    background-color: #fff;
    border-radius: 20px;
  }
  .modal-ti {
    text-align: center;
    font-size: 34px;
  }
  .img-ctx {
    margin: 40px auto 0;
    width: 400px;
    height: 400px;
  }
  .modal-img {
    display: block;
    width: 100%;
    height: 100%;
    -webkit-user-select: none;
    -webkit-touch-callout: none;
  }
  .img-place {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
</style>
